import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center my-3" }
const _hoisted_2 = { class: "col-lg-5" }
const _hoisted_3 = { class: "card card-catalog" }
const _hoisted_4 = { class: "mb-4 transition-y card-body" }
const _hoisted_5 = { class: "position-relative mb-3" }
const _hoisted_6 = { class: "image-box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 fs-15 mb-0" }
const _hoisted_10 = { class: "fw-medium" }
const _hoisted_11 = { class: "col-12 fs-15 mb-0" }
const _hoisted_12 = { class: "fw-medium" }
const _hoisted_13 = { class: "col-12 fs-15 mb-0" }
const _hoisted_14 = { class: "fw-medium" }
const _hoisted_15 = { class: "col-12 fs-15 mb-0" }
const _hoisted_16 = { class: "fw-medium" }
const _hoisted_17 = { class: "col-12 fs-15 mb-0" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "col-12 fs-15 mb-0" }
const _hoisted_20 = { class: "fw-medium" }
const _hoisted_21 = { class: "col-12 fs-15 mb-0" }
const _hoisted_22 = { class: "fw-medium" }
const _hoisted_23 = {
  key: 0,
  class: "col-12 fs-15 mt-4 text-center"
}
const _hoisted_24 = {
  key: 0,
  class: "col-lg-7"
}
const _hoisted_25 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_26 = { class: "card-body p-4" }
const _hoisted_27 = {
  key: 0,
  class: "table-content mt-5"
}

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useItemStore } from "@/stores/management/item";
import { ItemDataPayload, ItemDataResponse } from "@/types/interface/item";
import { mapOptionMultiselect, urlToObject } from "@/utils/helper";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailCatalog',
  setup(__props) {

const idItem = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const itemStore = useItemStore();
const detailItem = ref<ItemDataResponse>();
const listItem = ref<any>();
const page = ref(1);
const limit = ref(10);
const showTable = ref(false);

const loadItems = async () => {
  const { success, message } = await itemStore.dispatchGetItems(1, 99);
  if (success) {
    listItem.value = mapOptionMultiselect(
      await itemStore.items.items,
      "id",
      "name"
    );
  }
};

loadItems();

const loadDetailItem = async () => {
  const { success, message } = await itemStore.dispatchDetail(idItem.value);

  if (success) {
    detailItem.value = await itemStore?.item?.data;
    showTable.value = true;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    idItem.value = router.currentRoute.value.params.id.toString();
    loadDetailItem();
  }
});

const headers: Header[] = [
  { text: "MSG CODE", value: "msg_code" },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "TYPE", value: "key" },
  { text: "VALUE", value: "value" },
  { text: "Action", value: "action" },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center my-2" }, [
      _createElementVNode("a", {
        class: "btn btn-danger fw-semibold text-white px-3",
        type: "button",
        href: "/management/catalog"
      }, [
        _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
        _createTextVNode(" Back To List Item ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: detailItem.value?.image_link,
                class: "rounded-3",
                alt: "detailItem?"
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createTextVNode(" MSG CODE : ")),
              _createElementVNode("span", _hoisted_10, _toDisplayString(detailItem.value?.msg_code), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[1] || (_cache[1] = _createTextVNode(" IMPA CODE : ")),
              _createElementVNode("span", _hoisted_12, _toDisplayString(detailItem.value?.impa_code), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[2] || (_cache[2] = _createTextVNode(" Category : ")),
              _createElementVNode("span", _hoisted_14, _toDisplayString(detailItem.value?.category?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[3] || (_cache[3] = _createTextVNode(" Group Category : ")),
              _createElementVNode("span", _hoisted_16, _toDisplayString(detailItem.value?.groupCategory?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[4] || (_cache[4] = _createTextVNode(" Item : ")),
              _createElementVNode("span", _hoisted_18, _toDisplayString(detailItem.value?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[5] || (_cache[5] = _createTextVNode(" Unit : ")),
              _createElementVNode("span", _hoisted_20, _toDisplayString(detailItem.value?.unitType?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[6] || (_cache[6] = _createTextVNode(" Size : ")),
              _createElementVNode("span", _hoisted_22, _toDisplayString(detailItem.value?.size), 1)
            ]),
            (detailItem.value?.variant.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[7] || (_cache[7] = [
                  _createElementVNode("button", { class: "btn btn-primary btn-sm text-white" }, " Add To Requisition ", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (detailItem.value?.variant.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[9] || (_cache[9] = _createElementVNode("h5", null, "Varian Data", -1)),
              (showTable.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_unref(EasyDataTable), {
                      headers: headers,
                      items: detailItem.value?.variant
                    }, {
                      "item-action": _withCtx(() => _cache[8] || (_cache[8] = [
                        _createElementVNode("div", { class: "d-flex gap-2" }, [
                          _createElementVNode("button", { class: "btn btn-primary btn-sm text-white" }, " Add To Requisition ")
                        ], -1)
                      ])),
                      _: 1
                    }, 8, ["items"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})